import React, { useState, useEffect } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import { useForm } from 'react-hook-form';

import Model from './model';

// AWS Components
import { API, graphqlOperation } from 'aws-amplify';
import { createInvestor } from '../../graphql/mutations';

import TextFormField from './textFormField';
import PhoneFormField from './phoneFormField';
import SelectField from './selectField';
import EmailFormField from './emailFormField';

import Amplify from 'aws-amplify';
import config from '../../aws-exports';
Amplify.configure(config);

const InvestorIntakeForm = () => {
  const { register, errors, setError, handleSubmit } = useForm();
  const [values, setValues] = useState(Model.initialState);
  const [phone, setPhone] = useState('');
  const [signatureURL, setSignatureURL] = useState('');

  var _cavnas = null;

  useEffect(() => {
    return () => {
      console.log('Entered InvestorIntakeForm');
    };
  });

  const onSubmit = async (event) => {
    console.log('Event: ', event);
    try {
      const data = await API.graphql(
        graphqlOperation(createInvestor, {
          input: {
            ...event,
            signature: signatureURL.toDataURL(),
            phone: phone,
          },
        })
      );
      console.log('Data: ', data);
      setValues(Model.initialState);
      console.log('Data2: ', data);
      if (typeof window !== 'undefined') {
        window.location = '/meeting';
      }
    } catch (response) {
      console.log('Setting errors: ', response);
      // console.log("Drill Down errors: ", response.errors[0])
      // setError('phone', {
      //   type: 'manual',
      //   message: response.errors[0].message,
      // });
    }
  };

  return (
    <form
      id="createInvestor"
      className="measure center flex flex-wrap"
      onSubmit={handleSubmit(onSubmit)}
    >
      <h2 className="w-100">Contact Information</h2>
      <div className="w-100 w-50-l pr2-l mb2">
        <TextFormField
          name="firstname"
          label={`First Name *`}
          registerfunc={register}
          errorsfunc={errors}
          errortext="First name is required"
        />
      </div>
      <div className="w-100 w-50-l mb2">
        <TextFormField
          name="lastname"
          label={`Last Name *`}
          registerfunc={register}
          errorsfunc={errors}
          errortext="Last name is required"
        />
      </div>
      <div className="w-100 mb2">
        <TextFormField
          name="address"
          label={`Address *`}
          registerfunc={register}
          errorsfunc={errors}
          errortext="Address is required"
        />
      </div>
      <div className="w-100 w-50-l pr2-l mb2">
        <TextFormField
          name="city"
          label={`City *`}
          registerfunc={register}
          errorsfunc={errors}
          errortext="City is required"
        />
      </div>
      <div className="w-50">
        <SelectField
          name="state"
          label={`State *`}
          registerfunc={register}
          errorsfunc={errors}
          errortext="State is required"
        />
      </div>
      <div className="w-100 w-50-l pr2-l mb2">
        <TextFormField
          name="zip"
          label={`Zip *`}
          registerfunc={register}
          errorsfunc={errors}
          errortext="Zipcode is required"
        />
      </div>
      <div className="w-100 w-50-l mb2">
        <PhoneFormField
          name="phone"
          label={`Phone *`}
          onMyChange={setPhone}
          phone={phone}
          errorsfunc={errors}
          errortext="Phone is required. Format xxx-xxx-xxxx"
        />

        {errors.phone && (
          <p className="red f7 mb0 pb0">{errors['phone'].message}</p>
        )}
      </div>

      <div className="w-100 pr2-l">
        <EmailFormField
          name="email"
          label={`Email *`}
          registerfunc={register}
          errorsfunc={errors}
          errortext="Email is required"
        />
      </div>
      <h2 className="w-100">Investor Information</h2>
      <p className="f6">
        The Securities and Exchange Commission (SEC) requires us to know whether
        our investors meet the accredited and/or sophisticated investor
        standards to participate in a private equity offering.
      </p>
      <p className="f4 mb4">Please check all that apply</p>
      <label className="k--label-checkbox w-100 mb3">
        <input
          type="checkbox"
          name="income"
          id="income"
          value=""
          className="mr2"
          ref={register()}
        />
        Income: My annual net income was at least $200,000 in each of the last
        two years, or my joint income with my spouse was in excess of $300,000
        in each of those years, and I have reasonable expectation of the same
        income level in this year.
      </label>
      <label className="k--label-checkbox w-100 mb3">
        <input
          type="checkbox"
          name="assets"
          id="assets"
          value=""
          className="mr2"
          ref={register()}
        />
        Assets: My current individual net worth or joint net worth with my
        spouse is at least $1 million and does not include my personal
        residence.
      </label>
      <label className="k--label-checkbox w-100 mb3">
        <input
          type="checkbox"
          name="experience"
          id="experience"
          value=""
          className="mr2"
          ref={register()}
        />
        Experience: I am a business person with sufficient knowledge and
        experience in financial and business matters to the extent that I am
        capable of evaluating the risks and merits of a prospective investment.
      </label>
      <p className="f6 mt4">
        This is not an offer to sell or a solicitation of an offer to purchase
        an investment or security. This information relates to possible real
        estate opportunities for qualified purchasers who have established an
        existing substantive relationship with Aalon Capital LLC. Natural
        persons qualify as investors by virtue of such pre-existing
        relationships and by proof of business experience, income and net worth.
      </p>
      <p className="f6">I/we hereby certify the above is true and correct.</p>
      <label className="k--label mb0 pb0">
        Please use your mouse or finger to sign your name
      </label>
      <div className="ba bg-white">
        <SignatureCanvas
          id="signaturePad"
          penColor="green"
          ref={(ref) => {
            setSignatureURL(ref);
          }}
          canvasProps={{
            width: 550,
            height: 100,
            className: 'sigCanvas w-100',
          }}
        />
      </div>

      {errors.phone && <p>{errors.phone.message}</p>}

      <input
        className="b ph3 mt4 w-100 pv2 input-reset ba b--black bg-transparent grow pointer f6 dib bg-green white"
        type="submit"
        // disabled={!recaptcha}
        value="Send Investor Intake Form"
      />
    </form>
  );
};

export default InvestorIntakeForm;
